export const headerDiv = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom:'1rem'
}

export const leftHeader = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem'
}
